import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "markerWidth", "markerHeight", "refX", "refY"]
const _hoisted_2 = ["d", "fill", "transform"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LinePointMarker',
  props: {
    id: {},
    position: {},
    type: {},
    baseSize: {},
    color: {}
  },
  setup(__props: any) {

const props = __props

const pathMap = {
  dot: 'm0 5a5 5 0 1 0 10 0a5 5 0 1 0 -10 0z',
  arrow: 'M0,0 L10,5 0,10 Z',
}
const rotateMap: { [key: string]: number } = {
  'arrow-start': 180,
  'arrow-end': 0,
}

const path = computed(() => pathMap[props.type])
const rotate = computed(() => rotateMap[`${props.type}-${props.position}`] || 0)
const size = computed(() => props.baseSize < 2 ? 2 : props.baseSize)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("marker", {
    id: `${_ctx.id}-${_ctx.type}-${_ctx.position}`,
    markerUnits: "userSpaceOnUse",
    orient: "auto",
    markerWidth: size.value * 3,
    markerHeight: size.value * 3,
    refX: size.value * 1.5,
    refY: size.value * 1.5
  }, [
    _createElementVNode("path", {
      d: path.value,
      fill: _ctx.color,
      transform: `scale(${size.value * 0.3}, ${size.value * 0.3}) rotate(${rotate.value}, 5, 5)`
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})